import { render, staticRenderFns } from "./TeacherLessonsRecord.vue?vue&type=template&id=61177154&"
import script from "./TeacherLessonsRecord.vue?vue&type=script&lang=js&"
export * from "./TeacherLessonsRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAutocomplete,VIcon,VProgressCircular})
